'use strict';

import * as Toasts from './_app/toasts';

const escapeHtml = (text) => $('<div>').text(text).html();

const toggleGroup = (container, hasItems) => {
    const group = container.closest('.rg');
    group.toggleClass('d-none', !hasItems);

    const groups = group.closest('.rc').find('.rg');
    groups.removeClass('rg-last');
    groups.not('.d-none').last().addClass('rg-last');
}

const categoryPrefix = (searchString) => {
    if (typeof searchString !== 'string' || searchString.trim() === '') {
        return '';
    }
    return escapeHtml(searchString.trim()) + ' w';
}

const printAnchor = (e, type, specialText = '') => {
    const anchor = $('<a class="d-flex align-items-center">');
    const anchorWrapper = $('<div class="w-100 ps-3">');
    const categoryWrapper = $('<div class="w-100 d-flex">');
    if (e.url.length > 0) {
        if (type === 'product') {
            if (e.image !== null && e.image.length > 0) {
                anchor.attr('href', e.url);
                anchor.prepend($('<div class="shearch-product-img-container"><img loading="lazy" class="search-product-img" src="' + 'https://static.proline.pl/i/p/' + e.id + '/xs/' + e.image + '.jpg' + '" decoding="async" alt="' + e.name + '" /></div>')).append(anchorWrapper.append(
                    $('<p class="fs-6">' + e.name + '</p>')
                ).append($('<p class="fs-6">Od: ' + e.price + ' zł' + '</p>')));
                return anchor;
            } else {
                anchor.attr('href', e.url);
                anchor.prepend($('<div class="shearch-product-img-container"><img loading="lazy" class="search-product-img" src="' + 'img/no-photo.svg' + '" decoding="async" alt="' + e.name + '" /></div>')).append(anchorWrapper.append(
                    $('<p class="fs-6">' + e.name + '</p>')
                ).append($('<p class="fs-6">Od: ' + e.price + ' zł' + '</p>')));
                return anchor;
            }
        }
        if (type === 'category') {
            addTextToElement(anchor, type, e, specialText);
            anchor.attr('href', e.url);
            if (e.hasOwnProperty('image') && typeof e.image === 'string' && e.image.length) {
                categoryWrapper.append(anchor.prepend($('<div class="shearch-product-img-container"><img class="search-product-img" src="' + 'https://static.proline.pl/i/c/t/' + e.image + '.jpg' + '"/></div>')));

                return categoryWrapper;
            }

            return anchor;
        }
        if (type === 'producer') {
            anchor.attr('href', e.url);
            addTextToElement(anchor, type, e, specialText);
            return anchor;
        }
    }
    return anchor;
}

const print = (data, element, type, resultEl, specialText = '') => {
    $(resultEl + ' .' + element).empty();
    toggleGroup($(resultEl + ' .' + element), data.length > 0);
    if (data.length > 0) {
        $.each(data, function (i, e) {
            const a = printAnchor(e, type, specialText);
            $(resultEl + ' .' + element).append(a);
        });
    }
}


const printProducer = (data, resultElement) => {
    const resultEl = $(resultElement);
    if (resultEl.length === 1) {
        $('.p2', resultEl).empty();
        toggleGroup($('.p2', resultEl), data.length > 0);
        if (data.length > 0) {
            const producerContainer = $('<div class="d-flex flex-wrap gap-2 mb-3">');
            $.each(data, function (i, e) {
                const a = printAnchor(e, 'producer');
                a.addClass('border rounded py-2 px-3');
                producerContainer.append(a);
            });
            $('.p2', resultEl).append(producerContainer);
        }
    }
}

const printProduct = (data, resultElement) => {
    const resultEl = $(resultElement);
    if (resultEl.length === 1) {
        $('.p1', resultEl).empty();
        toggleGroup($('.p1', resultEl), data.length > 0);
        if (data.length > 0) {
            // Limit to first 8 products
            const limitedData = data.slice(0, 8);
            $.each(limitedData, function (i, e) {
                const a = printAnchor(e, 'product');
                $('.p1', resultEl).append(a);
            });
            if (resultElement === 'div#result1') {
                resultEl.siblings('form').addClass('search-focus')
            }
            resultEl.closest('form').addClass('search-focus');
            resultEl.closest('form').one('mouseleave', function () {
                resultEl.removeClass('search-hover');
            });
        } else {
            resultEl.closest('form').removeClass('search-focus');
        }
    }
}

const addTextToElement = (element, type, data = {'name': ''}, specialText = '') => {
    let textNode = '';
    if (typeof specialText !== 'undefined' && specialText.trim() !== '') {
        textNode = specialText;
    }
    if ('name' in data && typeof data.name !== 'undefined' && data.name.trim() !== '') {
        textNode = textNode + ' ' + data.name;
    }
    if (type === 'category') {
        element.append('<p class="mb-0 ps-3">' + textNode.trim() + '</p>');
    }
    if (type === 'producer') {
        element.append('<p class="mb-0">' + textNode.trim() + '</p>');
    }
}

const printError = () => {
    const searchForm = $('.fc.search .search-form');

    searchForm.addClass('search-focus')

    if (!$('.fc.search .search-form .rc').hasClass('d-none')) {
        $('.fc.search .search-form .rc').addClass('d-none');
    }

    if ($('.fc.search .search-form .rr .no-products').length <= 0) {
        $('.fc.search .search-form .rr').append($('<div class="no-products">Nie znaleziono żadnych produktów</div>'))
    }

}


const printErrorMobile = () => {
    $('.offcanvas-search form.search-form').addClass('search-focus')

    if (!$('.offcanvas-search #result1 .rc').hasClass('d-none')) {
        $('.offcanvas-search #result1 .rc').addClass('d-none');
    }

    if ($('.offcanvas-search #result1 .rr .no-products').length <= 0) {
        $('.offcanvas-search #result1 .rr').append($('<div class="no-products w-100 text-center">Nie znaleziono żadnych produktów</div>'))
    }

}

$(function () {
    $('.offcanvas-search .search').on('shown.bs.offcanvas', function () {
        $('html').css('overflow', 'hidden');
    })
    $('.offcanvas-search .search').on('hidden.bs.offcanvas', function () {
        $('html').css('overflow', 'auto');
    })

    $('input#search').on('click', function () {
        if ($('input#search').val().length > 0) {
            $('.btn-close-search-form').css('display', 'block')
        }
        if ($('input#search').val().length >= 2) {
            const reqData = $('input#search').val();
            $.ajax({
                type: "GET", url: "/search", dataType: "json", data: {
                    searchString: reqData, categoryId: $('select#searchSelect').find(':selected').data('value'),
                }, success: function (data) {
                    printProduct(data.products, 'div#result');
                    print(data.categories, 'p3', 'category', 'div#result', categoryPrefix(reqData));
                    printProducer(data.producers, 'div#result');
                }
            });

        }
    })

    $('input#search').on('keyup', function (e) {
        if (e.which === 27) {
            $('div#result').closest('form').removeClass('search-focus');
            $('#search').val('');
        } else if ($(this).val().length < 2) {
            $('div#result .p1').empty();
            $('div#result .p2').empty();
            $('div#result .p3').empty();
            $('div#result').closest('form').removeClass('search-focus');
        }
        if ($(this).val().length <= 0) {
            $('.btn-close-search-form').css('display', 'none');
        }
        if ($(this).val().length > 0) {
            $('.btn-close-search-form').css('display', 'block');
        }
    }).autocomplete({
        source: function (request, response) {
            $.ajax({
                type: "GET", url: "/search", dataType: "json", data: {
                    searchString: request.term, categoryId: $('select#searchSelect').find(':selected').data('value'),
                }, success: function (data) {
                    if (!data.products.length && !data.producers.length && !data.categories.length) {
                        printError()
                    } else {
                        if ($('.rc').hasClass('d-none')) {
                            $('.rc').removeClass('d-none');
                            $('.no-products').remove()
                        }
                        printProduct(data.products, 'div#result');
                        print(data.categories, 'p3', 'category', 'div#result', categoryPrefix(request.term));
                        printProducer(data.producers, 'div#result');
                    }
                }
            });
        }, minLength: 2
    });

    $('input#offcanvas-search')
        .on('keyup', function (e) {
            if (e.which === 27) {
                $('div#result1').siblings('form').removeClass('search-focus');
                $('#offcanvas-search').val('');
            } else if ($(this).val().length < 3) {
                $('div#result1 .p1').empty();
                $('div#result1 .p2').empty();
                $('div#result1 .p3').empty();
                $('div#result1').siblings('form').removeClass('search-focus');
            }
            if ($(this).val().length <= 0) {
                $('.btn-close-search-form-mobile').css('display', 'none');
            }
            if ($(this).val().length > 0) {
                $('.btn-close-search-form-mobile').css('display', 'block');
            }
        })
        .autocomplete({
            source: function (request, response) {
                $.ajax({
                    type: "GET", url: "/search", dataType: "json", data: {
                        searchString: request.term,
                    }, success: function (data) {
                        if (!data.products.length && !data.producers.length && !data.categories.length) {
                            printErrorMobile()
                        } else {
                            if ($('.rc-s').hasClass('d-none')) {
                                $('.rc-s').removeClass('d-none');
                                $('.no-products').remove()
                            }
                            printProduct(data.products, 'div#result1');
                            print(data.categories, 'p3', 'category', 'div#result1', categoryPrefix(request.term));
                            printProducer(data.producers, 'div#result1');
                        }
                    }
                });
            }, minLength: 3
        });

    $('.search-form > .input-group > .search-btn').on('click', function (e) {
        let searchString = $(this).siblings('input').val();
        if (searchString.length < 2) {
            e.preventDefault();
            Toasts.createToast(['bg-danger', 'Wpisz minimum 2 znaki']);
        } else {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'search',
                'search_term': `${searchString}`
            });
        }
    });

    $('.btn-close-search-form').on('click', function (e) {
        $(this).siblings('input').val('')
        $(this).closest('form').removeClass('search-focus');
        $('.btn-close-search-form').css('display', 'none');
    });

    $('.btn-close-search-form-mobile').on('click', function (e) {
        $(this).siblings('input').val('')
        $(this).closest('form').removeClass('search-focus');
        $('.btn-close-search-form-mobile').css('display', 'none');
    });

    $(window).on('resize', function () {
        if (window.innerWidth > 576) {
            const offcanvasSearch = $('#offcanvasSearch')
            if (offcanvasSearch.hasClass('show')) {
                const offcanvas = bootstrap.Offcanvas.getInstance(offcanvasSearch);
                offcanvas.hide();
                $('#offcanvas-search').val('')
                $('.btn-close-search-form-mobile').css('display', 'none');
            }
        } else {
            if ($('#search').val().length > 0) {
                $('#search').val('')
                $('.btn-close-search-form').css('display', 'none');
                $('.fc.search .search-form').removeClass('search-focus');
            }
        }
    })


    $(window).on('click', function (e) {
        if ($('.fc.search .search-form').hasClass('search-focus') && $(e.target).closest('.search-focus').length === 0) {
            $('.fc.search .search-form').removeClass('search-focus');
        }
    });
});
